module.exports = __webpack_public_path__ + "img/complete.2f584590.png";